export default "__VITE_ASSET__CBy2zEpp__"